import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  GuideMaterialApiRequest,
  UpdateGuideMaterialRequest,
  DeleteGuideMaterialRequest,
} from '@/data/payload/api/GuideMaterialRequest'
import { GuideMaterialPresenter } from '@/app/ui/presenters/GuideMaterialPresenter'
import { GuideMaterial } from '@/domain/entities/QuickGuideMaterial'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface GuideMaterialState {
  guideMaterialData: GuideMaterial
  isLoading: boolean
  fields: any
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'guideMaterials' })
class GuideMaterials extends VuexModule implements GuideMaterialState {
  public guideMaterialData = new GuideMaterial(true, '')
  public isLoading = true
  public Pages = 0
  public Limit = 10
  public fields = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'name', sortable: true },
    { key: 'totalFiles', sortable: false },
    { key: 'isActive', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'createdAt', sortable: false },
    { key: 'actions', sortable: false },
  ]
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
      Materialtype: 'SOP',
    },
    filter: {
      category: 1,
    },
    search: '',
  }

  @Action
  public async getGuideMaterialData() {
    this.setLoading(true)
    const presenter = await container.resolve(GuideMaterialPresenter)
    presenter
      .loadGuideMaterial(this.paginationParam)
      .then((res: GuideMaterial) => {
        this.setLoading(false)
        this.setGuideMaterialData(res)
        this.setpages(this.paginationParam.paging.page)
        this.setlimit(this.paginationParam.paging.limit)
        //  console.log('data', res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        router.push('/404/index')
        console.error('error', error)
      })
  }

  @Action
  public async postGuideMaterial(params: {
    title: string
    fileCode: string
    imageThumbnailId: number
    ownerId: string
    fileName: string
    fileByte: string
    fileUpload: any
    isRecommended: boolean
    categoryId: number
    expireddate: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(GuideMaterialPresenter)
    presenter
      .postGuideMaterial(
        new GuideMaterialApiRequest(
          params.title,
          params.fileCode,
          params.imageThumbnailId,
          params.fileName,
          params.fileByte,
          params.fileUpload,
          params.isRecommended,
          params.categoryId,
          params.expireddate,
          params.ownerId
        )
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'SOP',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getGuideMaterialData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async updateGuideMaterial(params: {
    id: number
    fileCode: string
    title: string
    recommended: boolean
    imageThumbnailId: number
    fileName: string
    fileByte: string
    fileUpload: any
    expireddate: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(GuideMaterialPresenter)
    presenter
      .updateGuideMaterial(
        new UpdateGuideMaterialRequest(
          params.title,
          params.fileCode,
          params.recommended,
          params.imageThumbnailId,
          params.fileName,
          params.fileByte,
          params.fileUpload,
          params.expireddate
        ),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'SOP',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getGuideMaterialData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async deleteGuideMaterial(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(GuideMaterialPresenter)
    presenter
      .deleteGuideMaterial(new DeleteGuideMaterialRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'SOP',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getGuideMaterialData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Mutation
  private setGuideMaterialData(guideMaterial: GuideMaterial) {
    this.guideMaterialData = guideMaterial
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  @Mutation
  private setpages(pages: number) {
    this.Pages = pages
  }
  @Mutation
  private setlimit(limit: number) {
    this.Limit = limit
  }
}

export const GuideMaterialDataModule = getModule(GuideMaterials)
